import axios from "axios"
const url = process.env.REACT_APP_URL

export const setAverageColor = async (RGBA: number[]) => {
  try {
    console.log(RGBA)
    const res = await axios.post(url + '/color/updateColor', {
      RGBA: RGBA
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const averageColor = async () => {
  try {
    const res = axios.get(url + '/color/getColor', {});
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}